module.exports = __webpack_public_path__ + "static/telephone-44527e743289bd85b01cc0c3668d13cb.png";